import { useTranslation } from 'react-i18next';
import { Guest } from '../../types/customer';
import Button from '../Button';
import pencilIcon from './icons/pencil.svg';
import pencilWhiteIcon from './icons/pencil-white.svg';

interface Props {
  guest: Guest;
  index: number;
  isLoading: boolean;
  confirmRemove: (email: string) => void;
  cancelRemove: () => void;
}

function PassengerRemove(props: Props) {
  const { t } = useTranslation(['bookings', 'common']);

  async function confirmRemove(email: string) {
    props.confirmRemove(email);
  }

  function cancelRemove() {
    props.cancelRemove();
  }

  return (
    <div className='flex flex-col items-center justify-center w-full'>
      <label className='font-rukaNeue text-xl block mb-2'>
        {`${t('Confirm Passenger Remove').toUpperCase()} ${props.index}?`}
      </label>
      <p className='mb-1'>{`${props.guest.FirstName} ${props.guest.Surname}`}</p>
      <p className='mb-1'>{props.guest.Email}</p>
      <p className='mb-4'>{props.guest.Mobile}</p>
      <div className='flex justify-center w-full'>
        <Button
          className='mr-2'
          icon={pencilWhiteIcon}
          onClick={() => confirmRemove(props.guest.Email)}
          disabled={props.isLoading}
        >
          {t('Remove')}
        </Button>
        <Button
          className='text-black border border-black'
          variant='transparent'
          icon={pencilIcon}
          onClick={() => cancelRemove()}
        >
          {t('Cancel')}
        </Button>
      </div>
    </div>
  );
}

export default PassengerRemove;
